module.exports = __webpack_public_path__ + "img/14_DSC8162-min.0e04e47b.jpg";